import { Container, Typography, Box } from '@mui/material';

export default function AdminPage() {
  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Typography variant="h2" gutterBottom>
        Администрирование
      </Typography>
      <Box sx={{ mt: 4 }}>
        <Typography variant="body1" color="text.secondary">
          Панель администратора в разработке...
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Здесь будут разделы:
        </Typography>
        <ul>
          <li>Управление мероприятиями</li>
          <li>Управление новостями</li>
          <li>Модерация заявок</li>
          <li>Экспорт участников</li>
        </ul>
      </Box>
    </Container>
  );
}
